export const getDomain = (hostname) => hostname.slice(hostname.indexOf('.'));
//# sourceMappingURL=index.js.map